// src/About.jsx

function About() {
  return (
    <section id="sobre" className="section section--alt">
      <div className="section-inner section-two-columns">
        <div className="about-main">
          <h2>Sobre mim</h2>
          <p>
            Sou a Karen, professora e entusiasta da ideia de que a escola pode ser um
            lugar vivo, em que estudantes criam, experimentam e erram sem medo. Minha
            trajetória passa pela tecnologia, pela sala de aula e pela pesquisa em
            Educação – e é nesse encontro que eu gosto de atuar.
          </p>
          <p>
            Trabalho com projetos que aproximam teoria e prática: hackathons
            educacionais, cultura maker, Aprendizagem Baseada em Projetos (ABP) e
            sequências didáticas que ajudam professores a transformar “conteúdo” em
            experiência. Gosto de estar junto das equipes, ouvindo o contexto de cada
            escola e construindo soluções possíveis, não receitas prontas.
          </p>
          <p>
            Hoje, atuo como professora, pesquisadora e consultora educacional,
            apoiando redes e escolas que querem inovar sem perder de vista aquilo que
            há de mais importante na educação: as pessoas.
          </p>
        </div>

        <div className="about-highlights">
          <h3>Como eu posso contribuir</h3>
          <ul>
            <li>Planejamento e facilitação de hackathons educacionais</li>
            <li>Implementação de ABP e cultura maker em diferentes etapas de ensino</li>
            <li>Desenvolvimento de sequências didáticas e materiais para professores</li>
            <li>Formação e mentoria para educadores e equipes gestoras</li>
            <li>Transformação Digital e aplicação de Tecnologias Educacionais no contexto escolar (TE na Prática)</li>

          </ul>

          <h3>Um pouco da minha trajetória</h3>
          <ul>
            <li>
              Doutoranda e Mestra em Ensino de Ciências, Matemática e Tecnologias,
              pesquisando hackathons educacionais e projetos integradores
            </li>
            <li>
              Experiência com redes públicas e privadas, sempre em diálogo com a
              realidade da escola
            </li>
            <li>
              Produção de artigos, sequência didática e materiais voltados à
              transformação digital na educação
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default About;
